import {
  DepositDetailWrapper,
  DepositTextWrapper,
  WalletAddressContainer,
} from "components/Deposit/styled";

import { Box, MenuItem, Select, Typography } from "@mui/material";
import { CircleButton } from "components/CircleButton";
import { StyledDepositDrawer } from "components/Deposit/styled";
import { Close } from "@mui/icons-material";
import { RetroButton } from "components/RetroButton";
import { Chain } from "chainConfigs";
import { CrossChainConfig, crossChainConfigs } from "../../hocs/withCrossChainDeposit";

const CrossChainDepositV1 = ({
  defaultChain,
  chains,
  isOpen,
  close,
  onCopySuccess,
  sortedConfigs,
  supporttedChainList,
  handleCopy,
  selectedChain,
  setSelectedChain,
  walletAddresses,
}: {
  defaultChain: Chain;
  chains: Chain[];
  isOpen: boolean;
  close: () => void;
  onCopySuccess: () => void;
  sortedConfigs: CrossChainConfig[];
  supporttedChainList: string[];
  handleCopy: () => void;
  selectedChain: Chain;
  setSelectedChain: (chain: Chain) => void;
  walletAddresses: Record<string, string>;
}) => {
  return (
    <StyledDepositDrawer anchor={"bottom"} open={isOpen} onClose={close}>
      <Box
        sx={{
          marginLeft: "auto",
          fontSize: "16px",
        }}>
        <CircleButton variant="white" onClick={close}>
          <Close fontSize="inherit" />
        </CircleButton>
      </Box>
      <DepositDetailWrapper>
        <Box
          sx={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            width: "100%",
            maxWidth: "495px",
            marginBottom: "16px",
            textAlign: "center",
          }}>
          <Typography variant="title-h1">Deposit to your wallet</Typography>
        </Box>
        <DepositTextWrapper>
          <Typography variant="body-default" color="text.secondary">
            Deposit {supporttedChainList.join(", ")} to start trading.
          </Typography>
        </DepositTextWrapper>
        <Select
          value={selectedChain}
          onChange={(event) => setSelectedChain(event.target.value as Chain)}
          sx={{ width: "100%", maxWidth: "495px", marginBottom: "16px" }}>
          {sortedConfigs.map((option, index) => {
            return (
              <MenuItem key={`cross-chain-modal-select-${index}`} value={option.id}>
                {option.networkName}
              </MenuItem>
            );
          })}
        </Select>
        <WalletAddressContainer>
          <Typography variant="body-md" color="text.primary">
            {walletAddresses
              ? walletAddresses[crossChainConfigs[selectedChain].walletName]
              : "Loading..."}
          </Typography>
        </WalletAddressContainer>
        <Box
          sx={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            width: "100%",
            maxWidth: "495px",
          }}>
          <RetroButton variant="primary" onClick={handleCopy}>
            <Typography variant="title-h3" sx={{ padding: "12px 21.5px" }}>
              COPY ADDRESS
            </Typography>
          </RetroButton>
        </Box>
      </DepositDetailWrapper>
    </StyledDepositDrawer>
  );
};

export default CrossChainDepositV1;
